import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const banner = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.75,
  type: 'Image178x100',
  associationType: 'banner-ad',
  className: 'boost-banner',
  imagePreviewHeight: 160,
  logoHeight: 20,
  isRequired: true,
  minimumRequirements: 1,
  minSize: [280, 160],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('Banner'),
    stringKey: _TL_('Banner'),
  },
  previewSettings: {
    showLogo: true,
    showShortHeadline: true,
    showAction: true,
    showBusinessName: false,
    showImage: false,
    showDismiss: true,
    dismissText: _TL_('Dismiss'),
  },
  styleOverrides: {
    cardParent: {
      marginTop: 'auto',
      marginBottom: 'auto',
      '& .responsive-ad-preview-content': {
        height: 35,
        width: '500px !important',
      },
      '& .logo-container': {
        position: 'absolute',
        top: '50%',
        left: 10,
        transform: 'translateY(-50%)',
      },
      '& .short-headline': {
        position: 'absolute',
        top: '50%',
        left: 40,
        fontSize: 12,
        color: 'black',
        transform: 'translateY(-50%)',
        width: 220,
      },
      '& .action-button': {
        position: 'absolute',
        top: '50%',
        left: 350,
        padding: '5px 10px',
        border: 'none',
        color: 'white',
        height: '24px',
        width: '60px',
        borderRadius: 10,
        backgroundColor: '#0078d4',
        transform: 'translateY(-50%)',
        fontSize: '10px !important',
      },
      '& .dismiss-button': {
        position: 'absolute',
        top: '50%',
        left: 430,
        border: 'none',
        padding: '5px 10px',
        borderRadius: 10,
        color: 'black',
        transform: 'translateY(-50%)',
      },
    },
  },
};

export default banner;
